import React from 'react';
import { SvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

const ThumbsUpIconSvg = styled(SvgIcon)`
  fill: ${props => (props.color ? 'currentColor' : 'none')};
  width: 24px;
  height: 24px;
  viewbox: '0 0 24 24';
  stroke: currentcolor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  width: 24px;
  height: 24px;
`;

const ThumbsUpIcon = props => (
  <ThumbsUpIconSvg {...props}>
    <path d='M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3'></path>
  </ThumbsUpIconSvg>
);

export default ThumbsUpIcon;
